import formatGrid from './formatGrid';
import themeEditor from './themeEditor';

export default () => {
  formatGrid();
  themeEditor();
};